import { WeekDays } from '@pogokid/util/datetime'
import { DayHours } from '../../types'

export interface WeekProps {
  weekDays: WeekDays[]
  weekStartOn: WeekDays
  startHour: DayHours
  endHour: DayHours
}

export const DEFAULT_WEEK_OPTIONS: WeekProps = {
  weekDays: [0, 1, 2, 3, 4, 5, 6],
  weekStartOn: 1,
  startHour: 0,
  endHour: 23,
}
